module.exports = __webpack_public_path__ + "static/grain-a576562a20bec87e6f1d8438f527e84e.png";